var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPfd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pfd",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7051",
    "data-name": "Rectangle 7051",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-pdf",
    "data-name": "Icon awesome-file-pdf",
    d: "M7.392,10.407A3.921,3.921,0,0,1,7.311,8.5C7.652,8.5,7.619,10,7.392,10.407Zm-.069,1.918a18.751,18.751,0,0,1-1.154,2.548,14.963,14.963,0,0,1,2.556-.89A5.264,5.264,0,0,1,7.323,12.325ZM3.5,17.4c0,.033.536-.219,1.418-1.634A5.617,5.617,0,0,0,3.5,17.4ZM10.078,6.5H15.6V19.831a.973.973,0,0,1-.975.975H.975A.973.973,0,0,1,0,19.831V.975A.973.973,0,0,1,.975,0H9.1V5.527A.978.978,0,0,0,10.078,6.5Zm-.325,6.981A4.079,4.079,0,0,1,8.018,11.3,5.841,5.841,0,0,0,8.27,8.688a1.018,1.018,0,0,0-1.942-.276,6.757,6.757,0,0,0,.329,3.129A38.159,38.159,0,0,1,5,15.027s0,0-.008,0C3.889,15.6,2,16.84,2.775,17.795a1.263,1.263,0,0,0,.874.406c.727,0,1.451-.731,2.483-2.511a23.163,23.163,0,0,1,3.21-.943,6.158,6.158,0,0,0,2.6.792,1.052,1.052,0,0,0,.8-1.764c-.565-.553-2.207-.394-2.991-.293ZM15.32,4.267,11.338.284A.975.975,0,0,0,10.647,0H10.4V5.2h5.2V4.954A.972.972,0,0,0,15.32,4.267ZM12.309,14.641c.167-.11-.1-.484-1.739-.366C12.077,14.918,12.309,14.641,12.309,14.641Z",
    transform: "translate(4.198 1.598)",
    fill: "#ee1717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfd);
export default __webpack_public_path__ + "static/media/pfd.dbc1e503d03f5163cd76bb385db7f433.svg";
export { ForwardRef as ReactComponent };